import dashboardReducers from "./reducers"
export { default as dashboardMiddleware } from "./middlewares";

export default dashboardReducers;